import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { loadDepartureRules, clearDepartureRules } from "@/utils/departureRulesCache";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("mz_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(!!localStorage.getItem("mz_token"));

  useEffect(() => {
    const token = localStorage.getItem("mz_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        localStorage.setItem("mz_user", JSON.stringify(data));
        loadDepartureRules(true).catch(() => {});
      })
      .catch(() => {
        localStorage.removeItem("mz_token");
        localStorage.removeItem("mz_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mz_token", data.token);
    localStorage.setItem("mz_user", JSON.stringify(data.user));
    setUser(data.user);
    loadDepartureRules(true).catch(() => {});
    return data.user;
  }, []);

  const driverLogin = useCallback(async (phone, accessCode) => {
    const { data } = await api.post("/auth/driver-login", { phone, access_code: accessCode });
    localStorage.setItem("mz_token", data.token);
    localStorage.setItem("mz_user", JSON.stringify(data.user));
    setUser(data.user);
    loadDepartureRules(true).catch(() => {});
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("mz_token");
    localStorage.removeItem("mz_user");
    setUser(null);
    clearDepartureRules();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, driverLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
